import axios from 'axios';
import Cookie from 'js-cookie';

const adminauthapiwithoutrefresh = axios.create( {
    baseURL: import.meta.env.TWC_AUTH_URL,
    validateStatus: function( status ) {
        return status >= 200 && status < 500;
    },
} );

const adminauthapi = axios.create( {
    baseURL: import.meta.env.TWC_AUTH_URL,
    validateStatus: function( status ) {
        return status >= 200 && status < 500;
    },
} );

const refreshAdminToken = async () => {
    let ref_token = Cookie.get( 'admin_refresh_token' );

    // if there is no refresh token, we need to logout
    if ( !ref_token ) {
        window.location = '/logout';
        return false;
    }

    const response = await axios.post( import.meta.env.TWC_AUTH_URL + '/token/refresh', null, {
        headers: {
            Authorization: `Bearer ${ref_token}`,
        },
    } ).catch( ( error ) => {
        window.location = '/logout';
    } );

    if ( response.status === 401 ) {
        window.location = '/logout';
        return false;
    }

    if ( response.status === 200 ) {
        const { accessToken } = response.data;
        Cookie.set( 'admin_access_token', accessToken, { expires: 3,
            sameSite: 'Strict' } );
        return true;
    }

    return false;
};

let handleRequest = async ( request ) => {
    const token = Cookie.get( 'admin_access_token' );

    if ( token ) {
        request.headers.Authorization = `Bearer ${token}`;
    }

    return request;
};

let handleResponse = async ( response ) => {
    const status = response.status;

    // unathorized (try to refresh token?)
    if ( status === 401 ) {
        // check if we already tried
        if ( response.config._retry ) {
            return response;
        }

        if ( await refreshAdminToken() ) {
            response.config._retry = true;
            return adminauthapi.request( response.config );
        }
    }

    return response;
};

const handleError = ( error ) => {
    return Promise.reject( error );
};

adminauthapi.interceptors.request.use( handleRequest, handleError );
adminauthapi.interceptors.response.use( handleResponse, handleError );

export { adminauthapi, refreshAdminToken, adminauthapiwithoutrefresh };
